<template>
    <div class="row">
        <input-mask class="col-12 col-md-6" label="Código do projeto" :placeholder="`PD-${empresaSelecionada.codigoANEEL}-`" :mask="[`PD-####-####/####`, `PD-#####-####/####`]" v-model="codigoProjeto" ref="codigo-projeto" required/>
        <div class="col-12 mb-2">
            <upload 
                id="projeto-importa-xml"
                tituloArquivo="Arrastar Arquivo" 
                selecioneArquivo="Selecionar Arquivo" 
                type=".xml"
                
                @upload="(file, nomeArquivo)=> {                   
                    form.nomeArquivo = nomeArquivo;
                    form.arquivoBase64 = file;
                }"
            />
        </div>
    </div>
</template>
<script>
import InputMask from "@/components/inputs/InputMask";
import Upload from "@/components/upload/Upload";
import { FormMixin } from "@/common/mixins/FormMixin";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import ProjetoService from "@/common/services/projeto/projeto.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import cloneDeep from "lodash/cloneDeep";
export default {
    mixins: [FormMixin, AlertasMixin],
    components: {
        InputMask,
        Upload
    },
    data : () => ({
        form : {
            ano : null,
            codigoInterno : null,
            nomeArquivo : null,
            arquivoBase64 : null
        },
        codigoProjeto : ""
    }),
    mounted(){
        //this.codigoProjeto = `PD-${this.empresaSelecionada.codigoANEEL}-`;
    },
    methods : {
        salvar : function(){
            if(!this.validateState())
                return false;

            let informacoes = this.codigoProjeto.replace(`PD-${this.empresaSelecionada.codigoANEEL}-`,"").split("/");
            this.form.codigoInterno = informacoes[0];
            this.form.ano = informacoes[1];
            this.form.codigoProjeto = this.codigoProjeto;
            this.form.codigoEmpresa = this.empresaSelecionada.codigoANEEL;

            if(this.form.arquivoBase64 == null){
                this.alertaErro("Arquivo XML é obrigatório");
                return false;
            } 
            
            this.confirmar("Deseja realmente criar projeto a partir do arquivo XML?").then(confirmar => {
                if(!confirmar)
                    return false;
                this.$store.dispatch(START_LOADING);
                let form = cloneDeep(this.form);
                form.arquivoBase64 = form.arquivoBase64.replace(/^data:.+;base64,/, "");
                ProjetoService.criarPorXML(form).then(() => {
                    this.alertaSucesso("Projeto criado com sucesso").then(() => {
                        this.$emit("salvo");
                    });
                    
                }).catch(err => {
                    if(err.response.status == 400){
                        this.alertaErro(err.response.data.errors);
                    }else{
                        this.alertaErro("Ocorreu um erro ao criar projeto!");
                    } 
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            })
        }
    },
    computed : {
        empresaSelecionada() {
            return this.$store.state.app.selectedCompanyObj;
        },
    }
    
}
</script>
<style lang="">
    
</style>